type NetPermissionType =
  | 'PERMITTED'
  | 'NO_AUTHORITY_PERMISSION'
  | 'NO_ROLE_PERMISSION'
  | 'NO_LEFT_LIMIT'
  | 'USAGE_EXCEEDED';

interface ResourceUsage {
  limit: number;
  usages: number;
  resourceName: string;
  onlyExceeded?: boolean;
}

interface NetPermission {
  isPermitted: boolean;
  message: string;
  type: NetPermissionType;
}

export function getNetPermission(params: {
  hasAuthorityPermission?: boolean;
  hasRolePermission?: boolean;
  resourceUsages?: ResourceUsage[];
}): NetPermission {
  if (params.hasAuthorityPermission === false) {
    return { isPermitted: false, message: '요금제 상담 필요', type: 'NO_AUTHORITY_PERMISSION' };
  }

  if (params.hasRolePermission === false) {
    return { isPermitted: false, message: '권한 없음', type: 'NO_ROLE_PERMISSION' };
  }

  // 여러 리소스의 사용량 체크가 가능하며, 배열 index를 기준으로 노출됩니다.
  if (params.resourceUsages) {
    const resourcePermissions = getResourceUsagePermissions(params.resourceUsages);
    const deniedPermission = resourcePermissions.find(
      (resourcePermission) => !resourcePermission.isPermitted
    );
    if (deniedPermission) {
      return deniedPermission;
    }
  }

  return { isPermitted: true, message: '', type: 'PERMITTED' };
}

function getResourceUsagePermissions(resourceUsages: ResourceUsage[]): NetPermission[] {
  return resourceUsages.map((resourceUsage) => {
    if (!resourceUsage.onlyExceeded && resourceUsage.limit === resourceUsage.usages) {
      return {
        isPermitted: false,
        message: `${resourceUsage.resourceName} 잔여 사용량 없음`,
        type: 'NO_LEFT_LIMIT',
      };
    }

    if (resourceUsage.limit < resourceUsage.usages) {
      return {
        isPermitted: false,
        message: `${resourceUsage.resourceName} 사용량 초과`,
        type: 'USAGE_EXCEEDED',
      };
    }
    return { isPermitted: true, message: '', type: 'PERMITTED' };
  });
}
